var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchanges(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 100,
    viewBox: "0 0 71 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7jul3i5coa",
    d: "M0 0h71v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "bkx8qb4ugb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7jul3i5coa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.757 18.793h33.5C52.22 11.07 45.96 4.75 38.247 4.75c-5.955 0-10.678-.586-15.377 4.136a14.073 14.073 0 0 0-4.113 9.906zM0 92.14v-70.98a2.372 2.372 0 0 1 2.38-2.367h11.63C14.034 8.485 22.454.006 32.755.006c7.2 0 12.825-.403 18.732 5.54a18.779 18.779 0 0 1 5.503 13.248h11.643A2.369 2.369 0 0 1 71 21.161v70.982C71 96.45 67.473 100 63.165 100H7.835C3.526 100 0 96.45 0 92.142v-.001z",
    mask: "url(#bkx8qb4ugb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.676 62v-5.163H33v-9.674h10.676V42L55 52.002zM28.497 76v-5.163H39v-9.679H28.497V56L16 65.998z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchanges);
export default __webpack_public_path__ + "static/media/exchanges.72eebf48ea914409571322df2e15f682.svg";
export { ForwardRef as ReactComponent };